<div class="table-wrp" [class]="mode">
  <div class="thc" #thc>
    <ng-container *ngIf="templates['thead-content']">
      <ng-content *ngTemplateOutlet="templates['thead-content']"></ng-content>
    </ng-container>
  </div>
<!--  <div #theadPlug class="thead-info-plug"></div>-->
  <table class="int-table" [style]="{'table-layout': tableLayout}" #tableEl>
    <thead #thead (contextmenu)="onHeadRightClickHandle($event)">
      <tr>
        <td *ngFor="let item of tableColsOrder" [class]="'td-' + headAlign" [style.width]="item?.width" (click)="onHeaderCellClick(item)">
          <ng-container *ngIf="templates[item.fieldName + '-head']; else defaultHead">
            <ng-content *ngTemplateOutlet="templates[item.fieldName + '-head'];context: {headData: item}"></ng-content>
          </ng-container>
          <ng-template #defaultHead>
            {{ item.label }}
          </ng-template>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of tableBodyData; let rowIndex = index"
        (click)="onRowClick(row)"
        [class]="isRowSelected(row) ? 'selected': ''"
      >
        <td *ngFor="let td of row" [class]="'td-' + td.fieldName + ' td-' + bodyAlign">
          <int-table-row-td
            [td]="td"
            [row]="row"
            [rowIndex]="rowIndex"
            [templates]="templates"
          ></int-table-row-td>
        </td>
      </tr>
    </tbody>
  </table>
</div>





